import {h, Fragment} from "preact"
import { useAppState } from "@nosto/preact"
import { useEffect } from "preact/hooks"
import { IS_EDITORIAL } from "../config"

import Product from "./Product"

export default function Products() {
    const { response: { products }, loading } = useAppState();

    useEffect(() => {
        if(!window.nostojs) return
        window.nostojs(api => {
            api.loadRecommendations(
                { skipPageViews: true, skipEvents: true }
            )
        })

        Nosto.migrateToShopifyMarket({
            productSectionElement: '.ns-product',
            productTitleElement: '.text-black.no-underline.ns-prod-link.prodName',
            productUrlElement: 'a',
            productHandleAttribute: 'data-handle',
            priceElement: '.ns-price',
            listPriceElement: '.ns-reg-price'
        })
    }, [ products.hits?.length ]);

    return (!IS_EDITORIAL ? (
        <ol
            className="ns-product-grid list-none m-0 p-0 grid grid-cols-2 lg:grid-cols-4 gap-x-2 gap-y-[60px]" 
            style={loading ? "opacity: 0.3;" : ""}
        >
            {products.hits.map((hit, index) => (
                <Product 
                    key={hit.productId || index} 
                    product={hit} 
                    editorialPos={false} 
                />
            ))}
        </ol>
    ) : ( //if editorial view: groups every 5 products into a row, making first or last product cards in row larger
        <div className="m-0 p-0 flex flex-col gap-4 lg:gap-[60px]">
            {products.hits.reduce((acc, hit, index) => {
                if (index % 5 === 0) {
                    acc.push([]);
                }
                acc[acc.length - 1].push(
                    <Product 
                        key={hit.productId || index} 
                        product={hit} 
                        editorialPos={((acc.length % 2 === 0) && ((index + 1) % 10 === 0)) 
                            ? 'first' 
                            : ((acc.length % 2 !== 0) && ((index + 1) % 5 === 0))
                                ? 'last'
                                : false
                        }
                    />
                );
                return acc;
            }, []).map((group, index) => ( // <ol> for each product row
                <ol className="list-none m-0 p-0 grid grid-cols-2 lg:grid-cols-4 gap-x-2 gap-y-4 lg:gap-y-[30px]" key={index}>
                    {group}
                </ol>
            ))}
        </div>
    ))
}
